import {
  type WorkerPaymentIncludedShift,
  type WorkerPaymentIncludedWorkplace,
  workerPaymentsContract,
} from "@clipboard-health/contract-worker-app-bff";
import { get } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { type PaymentsListItem } from "@src/appV2/redesign/Payments/Earnings/types/PaymentsListItem";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type AxiosError } from "axios";

export function useGetWorkerPaymentsByShift(
  shiftId: string,
  options?: { enabled?: boolean }
): UseQueryResult<PaymentsListItem[], AxiosError> {
  return useQuery({
    enabled: options?.enabled,
    queryKey: ["get-worker-payments-by-shift", shiftId],
    queryFn: async () => {
      const result = await get({
        url: `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/worker-payments`,
        queryParams: {
          "filter[shiftId]": shiftId,
        },
        responseSchema: workerPaymentsContract.list.responses[200],
      });

      return result.data.data.map((payment) => {
        const { workplaceId, shiftId: paymentShiftId } = payment.attributes;

        const workplace = result.data.included.find(
          (entity): entity is WorkerPaymentIncludedWorkplace =>
            entity.type === "workplace" && entity.id === workplaceId
        );

        const shift = result.data.included.find(
          (entity): entity is WorkerPaymentIncludedShift =>
            entity.type === "shift" && entity.id === paymentShiftId
        );

        return { ...payment, workplace, shift };
      });
    },
    meta: {
      userErrorMessage: "Failed to load payment history",
    },
  });
}
